import { COUNTRIES_ACTIONS } from 'constants/Actions/Countries';

// Estado inicial del reducer
const aInitialState = {
    aCountries: [],
    nTotalPages: 0,
    oCountry: null,

    bIsSuccess: false,
    bIsError: false,

    aCountriesSuggestion: [],
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los paises del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const CountryReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case COUNTRIES_ACTIONS.GET:
            return { ...aState, aCountries: oAction.data.data, nTotalPages: oAction.data.pages };
        case COUNTRIES_ACTIONS.FIND:
            return { ...aState, oCountry: oAction.data };
        case COUNTRIES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case COUNTRIES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case COUNTRIES_ACTIONS.CLEAN:
            return { ...aState, oCountry: null, bIsSuccess: false, bIsError: false };
        case COUNTRIES_ACTIONS.SUGGESTION:
            return { ...aState, aCountriesSuggestion: oAction.data };
        case COUNTRIES_ACTIONS.SUGGESTION_CLEAN:
            return { ...aState, aCountriesSuggestion: [] };
        default:
            return aState;
    }
}
